import http from "./constants/http";
import resources from "./constants/resources";

export const fetchListMemberAddress = async () => {
  const body = {
    modes: "ListSet",
  };
  const res = await http(resources.MEMBERADDRESS).post(body);
  if (res.status === 200) {
    return res.data;
  } else {
    return res;
  }
};

export const deleteMemberAddress = async (body) => {
  const res = await http(resources.MEMBERADDRESS).post(body);

  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
  };
  return resData;
};

export const insertMemberAddress = async (body) => {
  const res = await http(resources.MEMBERADDRESS).post(body);

  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
  };

  return resData;
};

export const updateMemberAddress = async (body) => {
  const res = await http(resources.MEMBERADDRESS).post(body);

  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
  };

  return resData;
};

export const defaultSetAddress = async (body) => {
  const res = await http(resources.MEMBERADDRESS).post(body);

  const resData = {
    code: res?.data?.Code,
    data: res?.data?.Data,
  };

  return resData;
};
